import React from 'react';

interface ContentProps {
  children: JSX.Element | JSX.Element[];
}

export function Content({ children }: ContentProps) {
  return <div className={`content-x content-y-screen flex flex-grow flex-col`}>{children}</div>;
}
